import { render, staticRenderFns } from "./CriaRecriaEvolui.vue?vue&type=template&id=66f2021b&scoped=true"
import script from "./CriaRecriaEvolui.vue?vue&type=script&lang=js"
export * from "./CriaRecriaEvolui.vue?vue&type=script&lang=js"
import style0 from "./CriaRecriaEvolui.vue?vue&type=style&index=0&id=66f2021b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f2021b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VChip,VCol,VRow})
